import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getUserRole } from './AuthService';
import LoadingSpinner from '../components/LoadingSpinner';

const AdminRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminRole = async () => {
      const token = localStorage.getItem('velaToken');
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const role = await getUserRole(token);
        setIsAdmin(role === 'admin');
      } catch (error) {
        console.error('Error checking admin role:', error);
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminRole();
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;
